<template>
  <div class="search-filter-view d-flex align-items-center">
    <div v-if="showInputSearch" class="flex-fill">
      <div class="input-view">
        <input v-model="text" :placeholder="placeholder" />
        <div
          v-if="showResultsDropdown"
          :class="`dropdown-suggestions p-5 ${dropdownVisible}`"
        >
          <div class="d-flex justify-content-end">
            <button class="btn btn-sm close-btn" @click="close">
              <i class="icon-x" />
            </button>
          </div>
          <slot />
        </div>
      </div>
    </div>

    <div v-if="showFilters" class="pl-3">
      <bp-filter-button
        description
        button-class="btn-sm btn-40"
        v-if="$permissions.hasPermission('pesquisar-vendas-por-periodo')"
      >
        <template #default="{ close }">
          <div class="p-5 position-relative">
            <div
              class="draggable-line d-flex justify-content-center d-lg-none mb-3"
              @click="close"
              role="button"
            ></div>
            <h5 class="text-left">{{ filterButtonText }}</h5>
            <small v-if="smallText.length" class="text-left text-secondary">
              {{ smallText }}
            </small>
            <div class="fit-scroll-content overflow-y-scroll">
              <slot name="custom-filter" :close="close" />
            </div>
          </div>
        </template>
      </bp-filter-button>
    </div>
  </div>
</template>

<script>
import { BpFilterButton } from "@/components/designSystem";
let timeout;

export default {
  components: { BpFilterButton },
  props: {
    showFilters: {
      type: Boolean,
      default: false
    },
    smallText: {
      type: String,
      default: ""
    },
    showResultsDropdown: {
      type: Boolean,
      default: true
    },
    showInputSearch: {
      type: Boolean,
      default: true
    },
    filterButtonText: {
      type: String,
      default: "Filtrar"
    },
    placeholder: {
      type: String,
      default: "ID transação, nome, e-mail"
    },
    size: {
      type: String,
      default: "lg"
    },
    value: {
      type: String,
      default: ""
    },
    newDesign: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: "",
      loading: true,
      dropdownVisible: "d-none",
      dialog: false
    };
  },
  watch: {
    text(newVal) {
      if (newVal.length) {
        this.show();
      } else {
        this.close();
      }
      this.$emit("input", newVal);

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.$emit("search", newVal);
      }, 300);
    }
  },
  methods: {
    show() {
      this.dropdownVisible = "d-block";
    },
    close() {
      this.dropdownVisible = "d-none";
    }
  }
};
</script>

<style lang="scss">
.search-filter-view {
  .input-view {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #a9a9a9;
    color: var(--l-neutral-3);
    border-radius: 6px;
    padding-left: 12px;
    max-height: 40px;
    min-height: 40px;
    width: 100%;
    position: relative;
    font-size: 14px;
  }

  .dropdown-suggestions {
    position: absolute;
    min-width: 450px;
    background: #fff;
    top: 120%;
    left: 0;
    z-index: 2;
    border: 1px solid #d2d0d8;
    border-radius: 4px;
  }

  span {
    color: #aeb6c4;
  }

  i {
    font-size: 24px;
  }

  .close-btn {
    min-height: 20px;
    max-height: 20px;
    i {
      font-size: 16px;
    }
  }

  input {
    display: flex;
    flex: 1;
    border: none;
    width: 100%;
    background: transparent;
    outline: none;
  }

  button {
    @media screen and (max-width: 991px) {
      display: block;
      padding: 10px;
      max-height: 46px;
    }
  }
}

.btn-close {
  position: absolute;
  top: -8px;
  right: 0;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.5);
}

.fit-scroll-content {
  @media screen and (max-width: 991px) {
    max-height: 550px;
  }
}
</style>
